// src/layout/PageLoader.jsx
// Shared Suspense fallback — used both while the post-login app shell
// (src/AppShell.jsx) loads, and inside it while individual pages load.

export default function PageLoader() {
  return (
    <div role="status" aria-label="Loading page" style={{
      display:"flex", alignItems:"center", justifyContent:"center",
      minHeight:300, gap:12,
    }}>
      <div style={{
        width:28, height:28, border:"3px solid #475569",
        borderTopColor:"#1a6b4a", borderRadius:"50%",
        animation:"spin 0.8s linear infinite",
      }} />
      <span style={{ fontSize:14, color:"#1e293b", fontWeight:600 }}>Loading...</span>
      <style>{`@keyframes spin{from{transform:rotate(0deg)}to{transform:rotate(360deg)}}`}</style>
    </div>
  );
}
